module.exports = __webpack_public_path__ + "img/emo_48.1a9bc729.png";